import { __assign } from "tslib";
import { logEvent } from '../../../lib/logs';
export function deleteFeeDetailLog(data) {
    if (data === void 0) { data = {}; }
    logEvent('delete_details_log', __assign({ title: '单据中删除明细' }, data));
}
export function deleteFeeDetail2RecordNote(data) {
    if (data === void 0) { data = {}; }
    logEvent('delete_details_to_RecordNote', __assign({ title: '单据中删除明细到随手记' }, data));
}
export function importFeeDetailLog(data) {
    if (data === void 0) { data = {}; }
    logEvent('import_details_log', data);
}
export function createBillFromRecordNote(data) {
    if (data === void 0) { data = {}; }
    logEvent('create_bill_from_recordNote', __assign({ title: '从随手记发起报销到单据' }, data));
}
export function saveFeeDetailLog() {
    logEvent('save_details_log', { title: '单据中保存明细' });
}
export function importFeeByExpenseLink(params) {
    logEvent('import_fee_by_expenseLink', params);
}
